import { ApiService } from "../index";
import { APIConfig } from "../../constants";


const getProjectChatHistories = (projectId: string, payload?: any) => {
    return ApiService[APIConfig.GET_CHAT_HISTORY.METHOD](APIConfig.GET_CHAT_HISTORY.URL(projectId), payload);
}

const getProjectDetails = (projectId: any, payload: any) => {
    return ApiService[APIConfig.GET_PROJECT_DETAILS.METHOD](APIConfig.GET_PROJECT_DETAILS.URL(projectId), payload);
}

const getProjectCode = (projectId: any, payload: any) => {
    return ApiService[APIConfig.GET_PROJECT_CODE.METHOD](APIConfig.GET_PROJECT_CODE.URL(projectId), payload);
}

const fetchProjectAssets = (projectId: any, payload: any) => {
    return ApiService[APIConfig.FETCH_PROJECT_ASSETS.METHOD](APIConfig.FETCH_PROJECT_ASSETS.URL(projectId), payload);
}

const getRequirementChatHistory = (projectId: string, payload?: any) => {
    return ApiService[APIConfig.GET_REQUIREMENT_CHAT_HISTORY.METHOD](APIConfig.GET_REQUIREMENT_CHAT_HISTORY.URL(projectId), payload)
}

const getSharedProjectCode = (projectId: string, payload?: any) => {
    return ApiService[APIConfig.GET_SHARED_PROJECT_CODE.METHOD](APIConfig.GET_SHARED_PROJECT_CODE.URL(projectId), payload)
}

const createSupabaseProject = (project: any) => {
    return ApiService[APIConfig.CREATE_SUPABASE_PROJECT.METHOD](APIConfig.CREATE_SUPABASE_PROJECT.URL, project)
}


const getUserProjects = (payload: any) => {
    return ApiService[APIConfig.GET_USER_PROJECTS.METHOD](APIConfig.GET_USER_PROJECTS.URL, payload);
}

const createProject = (payload: any) => {
    return ApiService[APIConfig.CREATE_PROJECT.METHOD](APIConfig.CREATE_PROJECT.URL, payload);
}

const supabaseLogin = (payload: any) => {
    return ApiService[APIConfig.SUPABASE_LOGIN.METHOD](APIConfig.SUPABASE_LOGIN.URL, payload);
}

const getSupabaseProjects = (payload?: any) => {
    return ApiService[APIConfig.GET_SUPABASE_PROJECTS.METHOD](APIConfig.GET_SUPABASE_PROJECTS.URL, payload)
}

const connectSupbaseToProject = (projectId: string, payload: any) => {
    return ApiService[APIConfig.CONNECT_SUPABASE_PROJECT.METHOD](APIConfig.CONNECT_SUPABASE_PROJECT.URL(projectId), payload)
}

const disconnectSupbaseFromProject = (projectId: string, payload: any) => {
    return ApiService[APIConfig.DISCONNECT_SUPABASE_PROJECT.METHOD](APIConfig.DISCONNECT_SUPABASE_PROJECT.URL(projectId), payload)
}

const updateCode = (projectId: string, payload: any) => {
    return ApiService[APIConfig.UPDATE_CODE.METHOD](APIConfig.UPDATE_CODE.URL(projectId), payload);
}


const getCommitData = (payload: any) => {
    return ApiService[APIConfig.GET_COMMIT_DATA.METHOD](APIConfig.GET_COMMIT_DATA.URL, payload);
}

const revertToASession = (projectId: string, payload: any) => {
    return ApiService[APIConfig.REVERT_TO_A_SESSION.METHOD](APIConfig.REVERT_TO_A_SESSION.URL(projectId), payload);
}

const deployApp = (projectId: string, payload: any) => {
    return ApiService[APIConfig.DEPLOY_APP.METHOD](APIConfig.DEPLOY_APP.URL(projectId), payload);
}

const generatePreview = (projectId: string, payload: any) => {
    return ApiService[APIConfig.GENERATE_PREVIEW.METHOD](APIConfig.GENERATE_PREVIEW.URL(projectId), payload);
}

const verifySubdomain = (payload: any) => {
    return ApiService[APIConfig.VERIFY_SUBDOMAIN.METHOD](APIConfig.VERIFY_SUBDOMAIN.URL, payload);
}

const connectSupabaseAuth = (paramString: string, payload?: any) => {
    return ApiService[APIConfig.CONNECT_SUPABASE_AUTH.METHOD](APIConfig.CONNECT_SUPABASE_AUTH.URL(paramString), payload)
}

const applyDataBaseChanges = (migrationId, payload: any) => {
    return ApiService[APIConfig.APPLY_DATABASE_CHANGES.METHOD](APIConfig.APPLY_DATABASE_CHANGES.URL(migrationId), payload)
}

const saveLogs = (payload: any) => {
    return ApiService[APIConfig.SAVE_LOGS.METHOD](APIConfig.SAVE_LOGS.URL, payload)
}

const updateProject = (projectId: string, payload: any) => {
    return ApiService[APIConfig.UPDATE_PROJECT.METHOD](APIConfig.UPDATE_PROJECT.URL(projectId), payload)
}

const createProjectAssetUrl = (projectId: string, payload: any) => {
    return ApiService[APIConfig.CREATE_PROJECT_ASSET_URL.METHOD](APIConfig.CREATE_PROJECT_ASSET_URL.URL(projectId), payload)
}

const uploadAssetToURL = (url: string, headers: any, payload: any) => {
    return ApiService[APIConfig.UPLOAD_ASSET_TO_URL.METHOD](url, payload, headers)
}

const getProjectAssets = (projectId: string, payload: any) => {
    return ApiService[APIConfig.GET_PROJECT_ASSETS.METHOD](APIConfig.GET_PROJECT_ASSETS.URL(projectId), payload)
}

const deleteProjectAsset = (projectId: string, assetName: string) => {
    return ApiService.delete(APIConfig.DELETE_PROJECT_ASSET.URL(projectId, assetName));
}

const getFlyLogErrors = (projectId: string) => {
    return ApiService.get(APIConfig.GET_FLY_LOG_ERRORS.URL(projectId));
}

const pauseSupabaseProject = (projectId: string, payload: any) => {
    return ApiService[APIConfig.PAUSE_SUPABASE_PROJECT.METHOD](APIConfig.PAUSE_SUPABASE_PROJECT.URL(projectId), payload)
}

const restoreSupabaseProject = (projectId: string, payload: any) => {
    return ApiService[APIConfig.RESTORE_SUPABASE_PROJECT.METHOD](APIConfig.RESTORE_SUPABASE_PROJECT.URL(projectId), payload)
}

const generatePromptFromPmConversation = (projectId: string, payload: any) => {
    return ApiService[APIConfig.GENERATE_PROMPT_FROM_PM_CONVERSATION.METHOD](APIConfig.GENERATE_PROMPT_FROM_PM_CONVERSATION.URL(projectId), payload)
}

const getProjectConversationHistory = (projectId: string, payload: any) => {
    return ApiService[APIConfig.GET_PM_CONVERSATION.METHOD](APIConfig.GET_PM_CONVERSATION.URL(projectId), payload)
}

const storeProjectApiKeys = (projectId: string, payload: any) => {
    return ApiService[APIConfig.STORE_PROJECT_API_KEYS.METHOD](APIConfig.STORE_PROJECT_API_KEYS.URL(projectId), payload);
}

const getProjectApiKeys = (projectId: string) => {
    return ApiService[APIConfig.GET_PROJECT_API_KEYS.METHOD](APIConfig.GET_PROJECT_API_KEYS.URL(projectId));
}

const createFlyCertificate = (projectId: string, payload: any) => {
    return ApiService[APIConfig.CREATE_FLY_CERTIFICATE.METHOD](APIConfig.CREATE_FLY_CERTIFICATE.URL(projectId), payload);
}

const getFlyCertificates = (projectId: string) => {
    return ApiService[APIConfig.GET_FLY_CERTIFICATES.METHOD](APIConfig.GET_FLY_CERTIFICATES.URL(projectId));
}

const ProjectService = {
    getProjectChatHistories,
    getProjectDetails,
    getProjectCode,
    fetchProjectAssets,
    getRequirementChatHistory,
    getSharedProjectCode,
    createSupabaseProject,
    getUserProjects,
    createProject,
    getSupabaseProjects,
    connectSupbaseToProject,
    updateCode,
    getCommitData,
    revertToASession,
    deployApp,
    generatePreview,
    verifySubdomain,
    supabaseLogin,
    connectSupabaseAuth,
    applyDataBaseChanges,
    saveLogs,
    updateProject,
    disconnectSupbaseFromProject,
    pauseSupabaseProject,
    restoreSupabaseProject,
    createProjectAssetUrl,
    uploadAssetToURL,
    getProjectAssets,
    deleteProjectAsset,
    getFlyLogErrors,
    generatePromptFromPmConversation,
    getProjectConversationHistory,
    storeProjectApiKeys,
    getProjectApiKeys,
    createFlyCertificate,
    getFlyCertificates
}

export default ProjectService;